<template>
  <v-container id="contents-container" class="contents-container">
    <v-layout column>
      <v-flex>
        <div class="headline my-10 text-center">
          Contact Us
        </div>
        <v-row>
          <v-col sm="6">
            <p class="headline">We are located in St.Catharines, ON</p>
            <p class="body-1">
              Please leave us a message and we will get back to you as soon as
              possible.
              <br />
              Email:
              <a href="mailto:info@shahrmin.com?subject=ContactUs">
                info@shahrmin.com
              </a>
            </p>
          </v-col>
          <v-col sm="6">
            <div class="mapouter text-center">
              <div class="gmap_canvas">
                <iframe
                  width="300"
                  height="300"
                  id="gmap_canvas"
                  src="https://maps.google.com/maps?q=st%20catharines%2C%20on&t=&z=11&ie=UTF8&iwloc=&output=embed"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0"
                ></iframe>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ContactAddress'
}
</script>

<style scoped>
.mapouter {
  position: relative;
  text-align: right;
  height: 400px;
  width: 400px;
}
.gmap_canvas {
  overflow: hidden;
  background: none !important;
  height: 400px;
  width: 400px;
}
</style>
